import React from "react";
import dayjs from "dayjs";
import utc from 'dayjs/plugin/utc';

dayjs.extend(utc);

const ChartHeader = ({title, date, cohortAnalysis = false}) => {
    const formattedDate = dayjs.utc(date).format('MM/DD/YYYY [at] HH:mm');
  return (
    <div className={`chartHeader ${cohortAnalysis ? "ml-5" : ""}`}>
      <h3 className="title">{title}</h3>
      <p className="date">Data last synced at: {formattedDate}</p>
    </div>
  );
};

export default ChartHeader;
